/**
 * Constantes compartilhadas. FONTE UNICA - nenhum sistema deve redefinir
 * gravidade, velocidade, altura de camera ou nome de superficie por conta propria.
 *
 * Escala do mundo: 1 unidade Three.js = 1 metro. Eixo Y para cima.
 */

export const WORLD = {
  GRAVITY: 22.0,              // m/s2 - acima do real, padrao de FPS (pulo curto e seco)
  UP: [0, 1, 0]
};

export const PLAYER = {
  RADIUS: 0.35,
  HEIGHT: 1.80,               // altura da capsula em pe
  CROUCH_HEIGHT: 1.15,
  EYE_HEIGHT: 1.65,           // altura do olho em pe, a partir dos pes
  CROUCH_EYE_HEIGHT: 1.02,
  STEP_HEIGHT: 0.45,          // degrau que sobe sem pular
  MAX_SLOPE_DEG: 48,

  WALK_SPEED: 4.2,            // m/s
  SPRINT_SPEED: 6.6,
  CROUCH_SPEED: 2.1,
  ADS_SPEED: 2.6,
  AIR_CONTROL: 0.28,
  ACCEL_GROUND: 60,
  ACCEL_AIR: 14,
  FRICTION: 11,
  JUMP_VELOCITY: 6.8,         // ~1.05 m de altura
  COYOTE_TIME: 0.12,
  JUMP_BUFFER: 0.15,

  MAX_HEALTH: 100,
  REGEN_DELAY: 4.5,           // segundos sem levar dano antes de regenerar
  REGEN_RATE: 22              // vida por segundo
};

/** Multiplicador de dano por regiao atingida. */
export const HITBOX_MULTIPLIER = {
  head: 3.2,
  chest: 1.0,
  stomach: 1.0,
  arm: 0.72,
  leg: 0.68
};

/**
 * Tipos de superficie. Usados por Materials (classificacao), FX (particula e
 * decalque) e Audio (som de impacto e passo). Nao invente valores fora desta lista.
 */
export const SURFACES = [
  'concrete', 'asphalt', 'brick', 'plaster', 'tile',
  'metal', 'metal_thin', 'wood', 'glass', 'dirt',
  'sand', 'gravel', 'grass', 'fabric', 'rubber',
  'water', 'flesh', 'sandbag'
];

/** Camadas de render/raycast. Use camera.layers / object.layers. */
export const LAYERS = {
  DEFAULT: 0,
  WORLD: 1,        // geometria estatica do cenario
  CHARACTER: 2,    // bots e hitboxes
  VIEWMODEL: 3,    // arma em primeira pessoa (renderizada na viewScene)
  FX: 4,           // particulas, tracers, decalques
  NO_SHADOW: 5     // objetos que nao entram no shadow map
};

/** Times. Bala amiga nao machuca quem e do mesmo time. */
export const TEAM = { PLAYER: 0, ENEMY: 1 };

export const GAME = {
  RESPAWN_DELAY: 3.0,
  WAVE_BREAK: 6.0,
  FIRST_WAVE_ENEMIES: 4,
  ENEMIES_GROWTH: 1.6,        // por onda
  MAX_ALIVE_ENEMIES: 12,
  SCORE_KILL: 100,
  SCORE_HEADSHOT_BONUS: 50
};
